export default {en:{hello:'Hello world'}};